import React from "react";
import styled from "styled-components";
import { Subtitle } from "./shared/Subtitle";
import { Title } from "./shared/Title";
import { FAQItem } from "./FAQItem";

const WrapperStyled = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  padding: 70px 5%;
`;

export const FAQs = () => {
  return (
    <WrapperStyled>
      <Subtitle>Preguntas frecuentes (FAQ)</Subtitle>
      <Title>¿Aún tienes dudas?</Title>
      <FAQItem question="¿Se nesitan conocimientos previos?">
        No, no necesitas conocimientos previos. Nuestro cursos estan diseñados
        para que puedas empezar desde cero.
      </FAQItem>
      <FAQItem question="¿Cómo es el proceso de admisión?">
        Después de que rellenes el formulario, te llamaremos, veremos si hacemos{" "}
        <i>match</i>, reservas tu plaza y... ¡Ya está! A principios de octubre
        serás un estudiante de Beyond the Code 🙂
      </FAQItem>
      <FAQItem question="¿A quién va dirigida esta formación?">
        Esta formación está dirigida a aquellos que buscan un giro profesional o
        a los que quieren reforzar conceptos que solo han aprendido
        teóricamente.
      </FAQItem>
      <FAQItem question="¿Qué modalidades de pago ofrecéis?">
        Se puede pagar integral en un único pago o en 2 partes (mitad al
        principio, mitad tras los 3 primeros meses). Si escoges el pago integral
        al inicio del curso te aplicaremos un 10% de descuento 😉
      </FAQItem>
      <FAQItem question="¿Cómo es la formación online?">
        En clases online grupales de 1,5h y dos veces a la semana.
      </FAQItem>
      <FAQItem question="¿En qué horario se imparten las clases?">
        Las clases se imparten los martes y jueves, de 19:00 a 20:30h.
      </FAQItem>
      <FAQItem question="¿Necesito tener mi propio ordenador?">
        Sí, la formación se imparte de forma remota, por lo que necesitas tu
        propio ordenador para participar en las clases online y para poder hacer
        los ejercicios relacionados.
      </FAQItem>
      <FAQItem question="¿Por qué elegir Beyond the Code?">
        <p>
          Beyond The Code lo formamos desarrolladores en activo que compaginamos
          el desarrollo de software con la labor docente. Por eso estamos al día
          de las últimas novedades del sector, conocemos qué es lo que demanda
          la industria y cuáles son las habilidades más solicitadas por los
          empleadores.
        </p>
        <p>
          Además, ya hemos pasado por todo el proceso formativo en el que te vas
          a embarcar. Por eso creamos Beyond the Code, para hacerte más fácil
          adquirir los conocimientos y la práctica que a nosotros nos llevó años
          por no recibir una formación mejor estructurada. Te vamos a enseñar
          como a nosotros nos habría gustado que no enseñaran 💪🚀
        </p>
      </FAQItem>
    </WrapperStyled>
  );
};
